import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowLeft, CheckCircle2 } from "lucide-react";
import { api, apiErrorMessage } from "@/lib/api";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState("");

    const onSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email: email.trim() });
            setDone(true);
        } catch (err) {
            setError(apiErrorMessage(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-5 py-12">
            <div className="w-full max-w-[440px] fade-up">
                <Link
                    to="/login"
                    className="link-red inline-flex items-center gap-1 text-sm mb-6"
                    data-testid="back-to-login"
                >
                    <ArrowLeft size={14} />
                    Back to sign in
                </Link>

                <p className="eyebrow">Account recovery</p>
                <h1 className="h1 mt-3">Forgot your password?</h1>
                <p className="text-muted mt-3">
                    Enter the email tied to your CPR Paint admin account. If we find a
                    match, we'll send a reset link.
                </p>

                {done ? (
                    <div
                        className="brand-card mt-8"
                        data-testid="forgot-done-card"
                        style={{ borderColor: "rgba(46,125,50,0.4)" }}
                    >
                        <CheckCircle2
                            size={28}
                            style={{ color: "var(--brand-success)" }}
                            className="mb-3"
                        />
                        <h3 className="h3">Check your inbox</h3>
                        <p className="text-muted mt-2 text-sm">
                            If <strong>{email}</strong> matches an account, a reset link is on
                            its way. The link is good for 1 hour.
                        </p>
                    </div>
                ) : (
                    <form className="mt-8 flex flex-col gap-5" onSubmit={onSubmit}>
                        <div>
                            <label className="field-label" htmlFor="email">
                                Email address
                            </label>
                            <input
                                id="email"
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="field-input"
                                placeholder="you@cprpainting.com"
                                data-testid="forgot-email-input"
                            />
                        </div>
                        {error && (
                            <div className="field-error" data-testid="forgot-error">
                                {error}
                            </div>
                        )}
                        <button
                            type="submit"
                            className="btn btn-primary w-full"
                            disabled={loading}
                            data-testid="forgot-submit-btn"
                        >
                            {loading ? "Sending…" : "Send reset link"}
                            {!loading && <ArrowRight size={16} />}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
}
